import {Routes} from '@angular/router';
import {ThongSoMoiTruongComponent} from '@entities/thong-so-moi-truong/thong-so-moi-truong.component';
import {UserRouteAccessService} from '@app/core';

export const thongSoMT: Routes = [
  {
    path: 'env-param/:id',
    component: ThongSoMoiTruongComponent,
    canActivate: [UserRouteAccessService],
  },
];
